import React from 'react';
import { Route, Routes } from 'react-router-dom';

import CreateProtocolPage from './CreateProtocolPage';
import EditProtocolPage from './EditProtocolPage';
import { ProtocolManagerContextProvider } from './ProtocolManagerContext';
import ProtocolManagerHomePage from './ProtocolManagerHomePage';

function ProtocolManagerRouter() {
    return (
        <div data-testid="protocol-manager-rewrite">
            <ProtocolManagerContextProvider>
                <Routes>
                    <Route path="/protocol/:protocolId" element={<EditProtocolPage />} />
                    <Route path="/protocol" element={<CreateProtocolPage />} />
                    <Route index element={<ProtocolManagerHomePage />} />
                </Routes>
            </ProtocolManagerContextProvider>
        </div>
    );
}

export default ProtocolManagerRouter;
